// extracted by mini-css-extract-plugin
export default {"root":"_2yxQk","left":"_24AJy","left-side-item-wrapper":"_1UG2o","leftSideItemWrapper":"_1UG2o","right":"_2Z5WV","right-side-item-wrapper":"_3D6VG","rightSideItemWrapper":"_3D6VG"};